(function(angular){
    'use strict';

    angular.module('onvio.setup.migrations').directive('fileCabinetFormToolbar', [function() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'setup/src/migrations/file-cabinet/fclist-form-toolbar.2js.html'
        };
    }]);

})(window.angular);
